import React, {Component} from "react";
import {deleteDocumentTemplate, getAllDocumentTemplates} from "../../../services/RequestService";
import ModalDocumentGenerator from "../../../components/settings/document-generator/ModalDocumentGenerator";
import {Header, Loading, PageContainer, TableComponent} from "../../../genericComponents";

class DocumentGeneratorPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: null,
      currentList: [],
      filterValue: "",
      show: false,
      data: undefined,
      loading: true,
    };
  }

  componentDidMount = () => {
    this.setState({ loading: true }, () => {
      getAllDocumentTemplates().then(({ ok, data }) => {
        if (ok) {
          this.setState({
            list: data.map((item) => ({
              id: item.id,
              description: item.description,
              variablesCount: item.variablesCount,
              updatedAt: item.updatedAt ? new Date(item.updatedAt).toLocaleDateString("pt-BR") : "",
            })),
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      });
    });
  };

  handleInputChange = (e) => {
    e.persist();
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  setShowModal = (show) => {
    this.setState({ show, data: undefined });
    if (!show) this.componentDidMount();
  };

  setModalForEditing = (data) => {
    this.setState({ data, show: true });
  };

  removeTemplate = (item) => {
    if (!window.confirm(`Excluir o modelo "${item.description}"?`)) return;
    deleteDocumentTemplate(item.id).then(({ ok }) => {
      if (ok) this.componentDidMount();
    });
  };

  filter = (item) => {
    const { filterValue } = this.state;
    return (item.description || "").toUpperCase().includes(filterValue.toUpperCase());
  };

  canCreate = () => {
    const { privileges, decodedToken } = this.props;
    return decodedToken?.is_admin || privileges?.["configuracoes/gerador_documento"]?.create;
  };

  canDelete = () => {
    const { privileges, decodedToken } = this.props;
    return decodedToken?.is_admin || privileges?.["configuracoes/gerador_documento"]?.delete;
  };

  render() {
    const { filterValue, show, data, loading } = this.state;
    return (
      <Loading loading={loading}>
        <Header
          active="Gerador de Documentos"
          logged
          filter={{
            type: "text",
            className: "text-left",
            placeholder: "Buscar por ... ",
            name: "filterValue",
            value: filterValue,
            onChange: this.handleInputChange,
          }}
          buttons={[
            this.canCreate()
              ? { onClick: () => this.setShowModal(true), icon: "fas fa-plus-circle", label: "Adicionar" }
              : null,
          ]}
        />
        <PageContainer fixedHeight className="p-3">
          <TableComponent
            loading={loading}
            countLabel="modelos"
            countLabelSingular="modelo"
            startSorted="id"
            header={[
              { label: "#", sortProperty: "id" },
              { label: "Descrição", sortProperty: "description" },
              { label: "Variáveis", sortProperty: "variablesCount" },
              { label: "Atualizado em" },
              this.canDelete() ? { label: "Excluir" } : null,
            ]}
            currentList={this.state.currentList}
            setCurrentList={(currentList) => this.setState({ currentList })}
            list={this.state.list?.filter(this.filter)}
            onItemClick={(item) => this.setModalForEditing(item)}
            forEach={(item) => [
              { label: item.id },
              { label: item.description },
              { label: item.variablesCount },
              { label: item.updatedAt },
              this.canDelete()
                ? {
                    onClick: () => this.removeTemplate(item),
                    label: (
                      <div className="text-center">
                        <i className="fas fa-trash-alt is-required"></i>
                      </div>
                    ),
                  }
                : null,
            ]}
          />
          {show && (
            <ModalDocumentGenerator
              show={show}
              onHide={() => this.setShowModal(false)}
              data={data && data}
            />
          )}
        </PageContainer>
      </Loading>
    );
  }
}

export default DocumentGeneratorPage;
